import { Button, message, Popconfirm, Space, Table, Input } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';

const AdminEmployess = () => {
  const [dataSource, setDataSource] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const apiUrl = process.env.REACT_APP_API_URL;
  const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;
  const navigate = useNavigate();
  const screens = useBreakpoint();

  const columns = [
    {
      title: 'Resim',
      dataIndex: 'img',
      key: 'img',
      render: (img) => {
        const imgSrc = img?.startsWith("http") ? img : `${imageBaseUrl}/${img}`;
        return (
          <img
            style={{ borderRadius: "50%", objectFit: "cover" }}
            src={imgSrc}
            width={50}
            height={50}
            alt="Çalışan"
          />
        );
      },
      responsive: ['sm', 'md', 'lg'],
    },
    {
      title: 'İsim',
      dataIndex: 'name',
      key: 'name',
      render: (text) => <b>{text}</b>,
      responsive: ['xs', 'sm', 'md', 'lg'],
    },
    {
      title: 'Çalışma Yeri',
      dataIndex: 'expertise',
      key: 'expertise',
      responsive: ['sm', 'md', 'lg'],
    },
    {
      title: 'Oluşturulma Tarihi',
      dataIndex: 'createdAt',
      key: 'createdAt',
      responsive: ['md', 'lg'],
    },
    {
      title: "İşlemler",
      key: "actions",
      render: (_, record) => (
        <Space size="middle">
          <Button onClick={() => navigate(`/admin/employess/update/${record.id}`)} type='primary'>
            Düzenle
          </Button>
          <Button onClick={() => navigate(`/admin/employess/${record.id}`)} type='primary'>
            Detay
          </Button>
          <Popconfirm
            title="Çalışan Sil"
            description="Çalışanı silmek istediğinizden emin misiniz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => deleteEmployess(record.id)}
          >
            <Button type='primary' danger>Sil</Button>
          </Popconfirm>
        </Space>
      ),
      responsive: ['xs', 'sm', 'md', 'lg'],
    }
  ];

  const deleteEmployess = async (employessId) => {
    try {
      const response = await fetch(`${apiUrl}/api/employess/${employessId}`, {
        method: "DELETE",
      });

      if (response.ok) {
        fetchEmployess();
        message.success("Çalışan başarıyla silindi");
      } else {
        message.error("Çalışan silme işlemi başarısız.");
      }
    } catch (error) {
      console.error("Silme Hatası", error);
    }
  };

  const fetchEmployess = useCallback(async () => {
    try {
      const response = await fetch(`${apiUrl}/api/employess`);
      if (response.ok) {
        const data = await response.json();
        setDataSource(data);
        setFilteredData(data);
      } else {
        message.error("Çalışanlar getirilemedi.");
      }
    } catch (error) {
      console.error("Veri çekme hatası", error);
    }
  }, [apiUrl]);

  useEffect(() => {
    fetchEmployess();
  }, [fetchEmployess]);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);

    const filtered = dataSource.filter(
      (item) =>
        item.name.toLowerCase().includes(value) ||
        item.expertise.toLowerCase().includes(value)
    );
    setFilteredData(filtered);
  };

  return (
    <>
      <Input
        placeholder="Çalışan ismi veya çalışma yeri ara..."
        value={searchText}
        onChange={handleSearch}
        style={{ marginBottom: 16, width: screens.xs ? '100%' : 300 }}
      />

      <Table
        pagination={{ pageSize: 5 }}
        rowKey={(record) => record.id}
        dataSource={filteredData}
        columns={columns}
        scroll={{ x: 'max-content' }}
      />
    </>
  );
};

export default AdminEmployess;
